import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
// GeneralViews
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
import Login from "@/pages/Login.vue";
import RedashContet from "../pages/RedashContent.vue";
import DatastudioContet from "../pages/DatastudioContent.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/current_status",
    children: [
      {
        path: "current_status",
        name: "Current Status",
        props: {
          isFilter: true,
          isDeliveredFilter: true,
          dashboardurl: "/dashboard/-global-current-situation?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "global_sales",
        name: "All-Entities Sales",
        props: {
          isFilter: true,
          isEntityFilter: true,
          isCurrencyFilter: true,
          dashboardurl: "/dashboard/-global-salse-information?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "global_customers",
        name: "All-Entities Customers",
        props: {
          isFilter: true,
          isEntityFilter: true,
          isDeliveredFilter: true,
          isCurrencyFilter: true,
          dashboardurl: "/dashboard/-global-customers-information?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "global_trainings",
        name: "All-Entities Trainings",
        props: {
          isFilter: true,
          isEntityFilter: true,
          isDeliveredFilter: true,
          dashboardurl: "/dashboard/-global-training-information?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "jp_sales",
        name: "JP Sales",
        props: {
          isFilter: true,
          isBranchFilter: true,
          dashboardurl: "/dashboard/-jp-sales-information?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "jp_customers",
        name: "JP Customers",
        props: {
          isFilter: true,
          isBranchFilter: true,
          isDeliveredFyFilter: true,
          dashboardurl: "/dashboard/-jp-customer-information?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "jp_trainings",
        name: "JP Trainings",
        props: {
          isFilter: true,
          isBranchFilter: true,
          isDeliveredFyFilter: true,
          dashboardurl: "/dashboard/-jp-training-information?fullscreen"
        },
        component: RedashContet
      },
      {
        path: "happiness",
        name: "Happiness",
        component: RedashContet,
        props: {dashboardurl: "/dashboard/-jp-happiness?p_組織名=Blits Branch&fullscreen"}
      },
      {
        path: "growth",
        name: "Growth",
        component: RedashContet,
        props: {dashboardurl: "/dashboard/-jp-glowth?fullscreen"}
      },
      {
        path: "souffle-activities",
        name: "Souffle Activities",
        component: RedashContet,
        props: {dashboardurl: "/dashboard/-jp-souffle-activities?fullscreen"}
      },
      {
        path: "souffle-discretions",
        name: "Souffle Discretion",
        component: RedashContet,
        props: {
          isFilter: true,
          isDeliveredFyFilter: true,
          dashboardurl: "/dashboard/-jp-souffle-discretions?fullscreen"
        }
      },
      {
        path: "souffle-contributions",
        name: "Rough profit and each contribution ranking",
        component: RedashContet,
        props: {
          isFilter: true,
          isDeliveredFyFilter: true,
          dashboardurl: "/dashboard/-jp-financial?fullscreen"
        }
      },
      {
        path: "jp_datastudio",
        name: "Datastudio(JP)",
        component: DatastudioContet,
        props: {datastudiourl: "https://datastudio.google.com/embed/reporting/1etoM0kEFdotblH2uzImW0-zHxp3Ip7Uv/page/P2NS"}
      },
      {
        path: "idn_datastudio",
        name: "Datastudio(IDN)",
        component: DatastudioContet,
        props: {datastudiourl: "https://datastudio.google.com/embed/reporting/1LKUCMOa8aV5dyoAHafRDtEkSAQ6FjqlE/page/TeVS"}
      },
      {
        path: "my_datastudio",
        name: "Datastudio(MY)",
        component: DatastudioContet,
        props: {datastudiourl: "https://datastudio.google.com/embed/reporting/1ucm8g7-cHk9hiU7_cHlsJ2AB11sfXYba/page/e6uY"}
      },
      {
        path: "sg_datastudio",
        name: "Datastudio(SG)",
        component: DatastudioContet,
        props: {datastudiourl: "https://datastudio.google.com/embed/reporting/1kqELXXlwg8GQsnzacgLaI9SIMQE8VU2U/page/e6uY"}
      },
      {
        path: "kr_datastudio",
        name: "Datastudio(KR)",
        component: DatastudioContet,
        props: {datastudiourl: "https://datastudio.google.com/embed/reporting/1YsZvyimMKIsGiEUqokEqxkpoxPjbwiz2/page/e6uY"}
      },
      {
        path: "login",
        name: "login",
        component: Login
      },
    ]
  },
  { path: "*", component: NotFound }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/


export default routes;
